import React, { Fragment } from "react";
//styles
import "./Lesson.scss";
// assets
import poster from "../../assets/images/poster.jpg";
import icon__favorite from "../../assets/icons/icon-favorite--2.svg";
import icon__favorited from "../../assets/icons/icon-favorited.svg";
import ReactPlayer from "react-player";
//components
import LessonBox from "../../components/LessonItem/LessonBox";
import { useSubscriptionContext } from "../../context/providers/SubscriptionContext";
import { useHistory } from "react-router-dom";
import { showErrorMessage, showSuccessMessage } from "../../utils/notification";
import { useLessonContext } from "../../context/providers/LessonContext";
import { useParams } from "react-router-dom";
import { useFavoriteContext } from "../../context/providers/FavoriteContext";
import Modal from "react-modal";
import { isIOS } from "react-device-detect";
import Plyr from "plyr-react";
import "plyr-react/dist/plyr.css";
const modalStylesReset = {
	overlay: {
		backgroundColor: "none",
	},
	content: {
		top: "10%",
		left: "10%",
		right: "10%",
		bottom: "10%",
		border: null,
		background: null,
		borderRadius: null,
		padding: null,
		position: null,
	},
};
Modal.setAppElement("#root");
export default function Lesson(props) {
	const [link, setLink] = React.useState("");

	const [activeModal, setActiveModal] = React.useState(false);

	const closeModal = () => {
		setLink("");
		setActiveModal(false);
	};

	const { lesson, nextLesson, getLesson } = useLessonContext();
	const {
		favorites,
		getFavorites,
		success: favoriteSuccess,
		error: favoriteError,
		clearNotification: clearFavoriteNotification,
		removeFromFavorite,
		addToFavorite,
	} = useFavoriteContext();
	const handleClick = () => {
		if (favorites.length > 0 && favorites.find((f) => f.lesson._id === id)) {
			let fId = favorites.find((f) => f.lesson._id === id)._id;
			removeFromFavorite(fId);
			//console.log();
		} else {
			addToFavorite(id);
		}
	};
	const { id, category } = useParams();
	const { isValid, checkSubscription, error, success, clearNotification } = useSubscriptionContext();
	let history = useHistory();
	const user = JSON.parse(localStorage.getItem("user"));
	React.useEffect(() => {
		getLesson(id, category);
		checkSubscription();
		getFavorites();
		if (error !== null) {
			showErrorMessage(error);
			clearNotification();
		}

		if (success !== null) {
			showSuccessMessage(success);
			clearNotification();
		}

		if (favoriteError !== null) {
			showErrorMessage(favoriteError);
			clearFavoriteNotification();
		}

		if (favoriteSuccess !== null) {
			showSuccessMessage(favoriteSuccess);
			clearFavoriteNotification();
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [success, favoriteSuccess, favoriteError]);

	return (
		<div className="container container--main d-xl-flex">
			<div className="container--content container--lesson">
				<div className="container--default lesson__video-container no_subscription position-relative">
					{/*<div
						className=" flex-grow-1 w-100 mt-2"
						style={{ display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "2rem" }}
					>
						<Loader type="TailSpin" color="#3326ae" height={50} width={50} style={{ marginTop: "3%" }} />
						<p className="input__label mt-3 " style={{ marginLeft: "15px" }}>
							Veuillez patienter
							</p>
					</div>*/}
					{lesson !== null && isValid !== null && isValid !== false && user.registerCompleted !== false ? (
						<Fragment>
							<video
									src={lesson.mainVideo.Location}
									controls
									className="lesson__video"
									controlsList="nodownload"
									autoplay
									preload
									muted
									loop
									playsinline
									
								></video>
							{/*isIOS ? (
								<video
									src={lesson.mainVideo.Location}
									controls
									className="lesson__video"
									controlsList="nodownload"
									autoplay
									preload
									muted
									loop
									playsinline
									
								></video>
							) : (
								<video
									src={lesson.mainVideo.Location}
									controls
									className="lesson__video"
									controlsList="nodownload"
								></video>
							)}
							{/*<VideoPop
								Src={lesson !== null && lesson.mainVideo.Location}
								Poster={poster}
								root="root"
								autoplay={false}
								ratio={{ w: 16, h: 9 }}
							/>*/}
							<button
								className={`btn btn--accent btn--bordered  lesson__video-favorite m-3 m-md-4`}
								onClick={handleClick}
							>
								<div>
									{favorites !== null && favorites.length > 0 && favorites.find((f) => f.lesson._id === id) ? (
										<img src={icon__favorite} alt="" />
									) : (
										<img src={icon__favorited} alt="" />
									)}
								</div>
							</button>
						</Fragment>
					) : (
						<Fragment>
							<img src={poster} alt="" className="lesson__video no_subscription" />
							<div className="lesson--no_subscription text-center d-flex flex-column align-items-center justify-content-center  fz--18">
								<p className="fw--600">
									{user.registerCompleted !== false
										? "You don't have an active subscription yet"
										: "Please confirm your email to access lesson	"}
								</p>
								{user.registerCompleted !== false ? (
									<button
										className="btn btn--white w-100 mt-3 mt-md-5"
										onClick={() => {
											history.push("/subscription");
										}}
									>
										Subscribe now
									</button>
								) : (
									""
								)}
							</div>
						</Fragment>
					)}
				</div>

				<div className="container--default px-3 py-4 mt-3 px-md-4 py-md-5 mt-md-4">
					<h1 className="container__title" style={{ marginBottom: "16px" }}>
						{lesson !== null && lesson.title}
					</h1>
					{lesson !== null && lesson.thumbnail.date && (
						<span
							className="lessons__item-desc "
							style={{
								marginBottom: "16px",
								fontSize: "16px",
								borderRadius: "1.6rem",
								padding: "0.4rem 1.6rem",
								backgroundColor: "#f4f5ff",
							}}
						>
							{lesson.thumbnail.date}
						</span>
					)}

					{lesson !== null && lesson.level && lesson.level !== "undefined" ? (
						<div className="d-flex lesson__tags mt-3">
							<div className="lesson__tag">
								{lesson.level && lesson.level === "undefined" ? "No information" : lesson.level}
							</div>
						</div>
					) : (
						""
					)}

					{lesson !== null && isValid !== null && isValid !== false && user.registerCompleted !== false ? (
						<Fragment>
							<div className="lesson__content">
								<p className="mt-4">{lesson.summary}</p>
								{lesson?.text && lesson.text.length > 0 && (
									<>
										{lesson.text.map((item, index) => (
											<p
												style={{
													textAlign: "justify",
												}}
												key={index}
												dangerouslySetInnerHTML={{
													__html: item.content,
												}}
												onClick={(e) => {
													const element = e.target;
													if (element instanceof HTMLImageElement) {
														console.log(e.target.src);
														setLink(e.target.src);
														setActiveModal(true);
													}

													/*for (var index = 0; index < images.length; index++) {
														const element = images[index];
														element.addEventListener("click", function (e) {
															e.preventDefault();
															console.log(`cliked`);
															alert("hello");
															return;
														});
														//console.log(element);
													}*/
												}}
											/>
										))}
									</>
								)}
							</div>
						</Fragment>
					) : (
						<Fragment>
							<p className="mt-3">{lesson !== null && lesson.summary}</p>
							<p className="mt-4 fw--600 color--primary">
								{user.registerCompleted !== false
									? "Subscribe to have an access to educational materials"
									: "Please confirm your email to access lesson"}
							</p>
						</Fragment>
					)}
				</div>
			</div>
			<div className="d-md-flex d-xl-block mt-3 mt-md-4 mt-xl-0 ml-xl-5">
				<div className="lessons container--default">
					{nextLesson !== null && nextLesson.length > 0 && <LessonBox item={nextLesson[0]} />}
					{nextLesson !== null && nextLesson.length > 1 && <LessonBox item={nextLesson[1]} />}
				</div>
			</div>
			{activeModal && (
				<Modal
					isOpen={activeModal}
					onRequestClose={closeModal}
					style={modalStylesReset}
					contentLabel="Example Modal"
					shouldCloseOnOverlayClick={true}
				>
					<img
						src={link}
						alt=""
						style={{
							width: "70%",
							height: "90%",
						}}
						onClick={closeModal}
					/>
				</Modal>
			)}
		</div>
	);
}
